"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDashesToString = exports.fixDateToISO = exports.getColumnOption = exports.getColumnOptionMetadata = exports.getItemInbox = exports.getItemsFromSubscriptions = exports.getUsernamesFromFilter = exports.getValuesFromQueryKeysFilter = exports.getFilterFromSearchQuery = exports.getSearchQueryTerms = exports.getQueryStringFromQueryTerms = exports.getSearchQueryFromFilter = exports.getSubscriptionOwnerOrOrg = exports.intercalateWithArray = exports.genericGitHubResponseMapper = exports.convertObjectKeysToCamelCase = exports.normalizeUsername = exports.stripMarkdown = exports.removeUselessURLsFromResponseItem = exports.deepMapper = exports.isIssueOrPullRequestPrivate = exports.isNotificationPrivate = exports.isEventPrivate = exports.trimNewLinesAndSpaces = exports.randomBetween = exports.getSteppedSize = exports.getDateSmallText = exports.getFullDateText = exports.isNight = exports.guid = exports.memoizeMultipleArgs = exports.capitalize = void 0;
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const filters_1 = require("./filters");
const github_1 = require("./github");
function capitalize(str) {
    return str.toLowerCase().replace(/^.| ./g, lodash_1.default.toUpper);
}
exports.capitalize = capitalize;
function memoizeMultipleArgs(fn) {
    return lodash_1.default.memoize(fn, (...args) => JSON.stringify(args));
}
exports.memoizeMultipleArgs = memoizeMultipleArgs;
function guid() {
    const str4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1); // tslint:disable-line
    return `${str4() + str4()}-${str4()}-${str4()}-${str4()}-${str4()}${str4()}${str4()}`;
}
exports.guid = guid;
function isNight() {
    const hours = new Date().getHours();
    return hours >= 18 || hours < 6;
}
exports.isNight = isNight;
function getFullDateText(date) {
    if (!date)
        return '';
    const momentDate = moment_1.default(date);
    if (!momentDate.isValid())
        return '';
    return momentDate.format('llll');
}
exports.getFullDateText = getFullDateText;
function getDateSmallText(date, { includeExactTime = false, pastPrefix = '', pastSuffix = '', showPrefixOnFullDate = false, futurePrefix = '', futureSuffix = '', showSuffixOnFullDate = false, } = {
    futurePrefix: 'in',
}) {
    if (!date)
        return '';
    const momentDate = moment_1.default(date);
    if (!momentDate.isValid())
        return '';
    const momentNow = moment_1.default(new Date());
    const timeText = momentDate.format('HH:mm');
    const _secondsDiff = momentNow.diff(momentDate, 'seconds');
    const isInFuture = _secondsDiff < 0;
    const prefix = (isInFuture ? futurePrefix && `${futurePrefix} ` : pastPrefix && `${pastPrefix} `) || '';
    const suffix = (isInFuture ? futureSuffix && ` ${futureSuffix}` : pastSuffix && ` ${pastSuffix}`) || '';
    const fullDatePrefix = showPrefixOnFullDate ? prefix : '';
    const fullDateSuffix = showSuffixOnFullDate ? suffix : '';
    const secondsDiff = Math.abs(_secondsDiff);
    const minutesDiff = Math.abs(momentNow.diff(momentDate, 'minutes'));
    const hoursDiff = Math.abs(momentNow.diff(momentDate, 'minutes') >= 60 ? Math.round(secondsDiff / (60 * 60)) : Math.floor(secondsDiff / (60 * 60)));
    const daysDiff = Math.abs(momentNow.diff(momentDate, 'hours') >= 24 ? Math.round(secondsDiff / (24 * 60 * 60)) : Math.floor(secondsDiff / (24 * 60 * 60)));
    if (daysDiff < 1) {
        if (hoursDiff < 1) {
            if (minutesDiff < 1) {
                if (secondsDiff <= 1) {
                    return `${fullDatePrefix}now${fullDateSuffix}`;
                }
                return `${prefix}${secondsDiff}s${suffix}`;
            }
            return `${prefix}${minutesDiff}m${suffix}${includeExactTime ? ` (${timeText})` : ''}`;
        }
        return `${prefix}${hoursDiff}h${suffix}${includeExactTime ? ` (${timeText})` : ''}`;
    }
    if (daysDiff <= 3) {
        return `${prefix}${daysDiff}d${suffix}${includeExactTime ? ` (${timeText})` : ''}`;
    }
    if (momentDate.year() !== moment_1.default().year()) {
        return `${fullDatePrefix}${momentDate.format('ll')}${fullDateSuffix}`;
    }
    return `${fullDatePrefix}${momentDate.format('MMM Do')}${fullDateSuffix}`;
}
exports.getDateSmallText = getDateSmallText;
// sizes will be multiples of 50 for caching (e.g 50, 100, 150, ...)
function getSteppedSize(size, sizeSteps = 50, getPixelSizeForLayoutSizeFn) {
    const steppedSize = typeof size === 'number' ? sizeSteps * Math.max(1, Math.ceil(size / sizeSteps)) : sizeSteps;
    return getPixelSizeForLayoutSizeFn ? getPixelSizeForLayoutSizeFn(steppedSize) : steppedSize;
}
exports.getSteppedSize = getSteppedSize;
function randomBetween(minNumber, maxNumber) {
    return Math.floor(Math.random() * maxNumber) + minNumber;
}
exports.randomBetween = randomBetween;
function trimNewLinesAndSpaces(text, maxLength = 120) {
    if (!text || typeof text !== 'string')
        return '';
    let newText = text.replace(/\s+/g, ' ').trim();
    if (maxLength > 0 && newText.length > maxLength) {
        newText = `${newText.substr(0, maxLength).trim()}...`;
    }
    return newText;
}
exports.trimNewLinesAndSpaces = trimNewLinesAndSpaces;
function isEventPrivate(event) {
    if (!event)
        return false;
    return !!(event.public === false || ('repo' in event && event.repo && event.repo.private) || ('repos' in event && event.repos && event.repos.some((repo) => repo.private)));
}
exports.isEventPrivate = isEventPrivate;
function isNotificationPrivate(notification) {
    if (!notification)
        return false;
    return !!(notification.repository && notification.repository.private);
}
exports.isNotificationPrivate = isNotificationPrivate;
function isIssueOrPullRequestPrivate(_issueOrPullRequest) {
    return !!(_issueOrPullRequest && _issueOrPullRequest.private);
}
exports.isIssueOrPullRequestPrivate = isIssueOrPullRequestPrivate;
function deepMapper(obj, mapper) {
    if (!(obj && lodash_1.default.isPlainObject(obj)))
        return obj;
    return mapper(lodash_1.default.mapValues(obj, (v) => (lodash_1.default.isPlainObject(v) ? deepMapper(v, mapper) : v)));
}
exports.deepMapper = deepMapper;
const urlsToKeep = ['url', 'html_url', 'avatar_url', 'latest_comment_url'];
function removeUselessURLsFromResponseItem(item) {
    let hasChanged = false;
    const result = deepMapper(item, (obj) => {
        const keys = Object.keys(obj);
        keys.forEach((key) => {
            if (!(key && typeof key === 'string'))
                return;
            if (!(key.includes('_url') || key.includes('_link') || key.includes('href')))
                return;
            if (!urlsToKeep.includes(key)) {
                hasChanged = true;
                delete obj[key];
            }
        });
        return obj;
    });
    if (!hasChanged)
        return item;
    return result;
}
exports.removeUselessURLsFromResponseItem = removeUselessURLsFromResponseItem;
// Modified version of: https://github.com/stiang/remove-markdown
// License: MIT
function stripMarkdown(md, _options) {
    if (!(md && typeof md === 'string'))
        return '';
    const options = _options || {};
    options.listUnicodeChar = options.hasOwnProperty('listUnicodeChar') ? options.listUnicodeChar : false;
    options.stripListLeaders = options.hasOwnProperty('stripListLeaders') ? options.stripListLeaders : true;
    options.githubFlavoredMarkdown = options.hasOwnProperty('gfm') ? options.githubFlavoredMarkdown : true;
    options.useImgAltText = options.hasOwnProperty('useImgAltText') ? options.useImgAltText : true;
    let output = md || '';
    // Remove horizontal rules (stripListHeaders conflict with this rule, which is why it has been moved to the top)
    output = output.replace(/^(-\s*?|\*\s*?|_\s*?){3,}\s*$/gm, '');
    try {
        if (options.stripListLeaders) {
            if (options.listUnicodeChar)
                output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, `${options.listUnicodeChar} $1`);
            else
                output = output.replace(/^([\s\t]*)([\*\-\+]|\d+\.)\s+/gm, '$1');
        }
        if (options.githubFlavoredMarkdown) {
            output = output
                // Header
                .replace(/\n={2,}/g, '\n')
                // Fenced codeblocks
                .replace(/~{3}.*\n/g, '')
                // Strikethrough
                .replace(/~~/g, '')
                // Fenced codeblocks
                .replace(/`{3}.*\n/g, '');
        }
        output = output
            // Remove HTML tags
            .replace(/<[^>]*>/g, '')
            // Remove Comments
            .replace(/<[^>]*>/g, '')
            .replace(/\>(.*)([\r\n]+|$)/g, '')
            // Remove setext-style headers
            .replace(/^[=\-]{2,}\s*$/g, '')
            // Remove footnotes?
            .replace(/\[\^.+?\](\: .*?$)?/g, '')
            .replace(/\s{0,2}\[.*?\]: .*?$/g, '')
            // Remove images
            .replace(/\!\[(.*?)\][\[\(].*?[\]\)]/g, options.useImgAltText ? '$1' : '')
            // Remove inline links
            .replace(/\[(.*?)\][\[\(].*?[\]\)]/g, '$1')
            // Remove blockquotes
            .replace(/^\s{0,3}>\s?/g, '')
            // Remove reference-style links?
            .replace(/^\s{1,2}\[(.*?)\]: (\S+)( ".*?")?\s*$/g, '')
            // Remove atx-style headers
            .replace(/^(\n)?\s{0,}#{1,6}\s+| {0,}(\n)?\s{0,}#{0,} {0,}(\n)?\s{0,}$/gm, '$1$2$3')
            // Remove emphasis (repeat the line to remove double emphasis)
            .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
            .replace(/([\*_]{1,3})(\S.*?\S{0,1})\1/g, '$2')
            // Remove code blocks
            .replace(/(`{3,})(.*?)\1/gm, '$2')
            // Remove inline code
            .replace(/`(.+?)`/g, '$1')
            .replace(/`/g, '')
            // Replace two or more newlines with exactly two? Not entirely sure this belongs here...
            .replace(/\n{2,}/g, '\n\n');
    }
    catch (e) {
        console.error(e);
        return md;
    }
    return output;
}
exports.stripMarkdown = stripMarkdown;
function normalizeUsername(username) {
    if (!username || typeof username !== 'string')
        return undefined;
    return username.trim().toLowerCase();
}
exports.normalizeUsername = normalizeUsername;
function convertObjectKeysToCamelCase(obj) {
    return lodash_1.default.mapKeys(obj, (_value, key) => lodash_1.default.camelCase(key));
}
exports.convertObjectKeysToCamelCase = convertObjectKeysToCamelCase;
function genericGitHubResponseMapper(response) {
    if (!(response && lodash_1.default.isPlainObject(response)))
        return response;
    return lodash_1.default.mapValues(convertObjectKeysToCamelCase(response), (obj) => {
        if (lodash_1.default.isPlainObject(obj))
            return genericGitHubResponseMapper(obj);
        return obj;
    });
}
exports.genericGitHubResponseMapper = genericGitHubResponseMapper;
function intercalateWithArray(arr, separator) {
    return lodash_1.default.flatMap(arr, (item, index) => (index === 0 ? item : [separator, item]));
}
exports.intercalateWithArray = intercalateWithArray;
function getSubscriptionOwnerOrOrg(subscription) {
    if (!(subscription && subscription.params))
        return undefined;
    if ('owner' in subscription.params && subscription.params.owner)
        return subscription.params.owner;
    if ('org' in subscription.params && subscription.params.org)
        return subscription.params.org;
    const { allIncludedOwners, allIncludedRepos } = filters_1.getOwnerAndRepoFormattedFilter('owners' in subscription.params ? { owners: subscription.params.owners } : undefined);
    const _org = allIncludedOwners.length === 1 ? allIncludedOwners[0] : undefined;
    const _ownerAndRepo = allIncludedRepos.length === 1 ? github_1.getOwnerAndRepo(allIncludedOwners[0]) : { owner: undefined, repo: undefined };
    return _org || _ownerAndRepo.owner || undefined;
}
exports.getSubscriptionOwnerOrOrg = getSubscriptionOwnerOrOrg;
function getSearchQueryFromFilter(type, filters, { groupByKey = false } = {}) {
    if (!(type && filters))
        return '';
    const queries = [];
    const { 
    // clearedAt,
    bot, draft, owners, private: _private, query, saved, state: states, subjectTypes, unread, } = filters;
    const { activity, watching } = filters;
    const { involves } = filters;
    const { notifications } = filters;
    function getMaybeNegate(filter) {
        return filter === false ? '-' : '';
    }
    function handleRecordFilter(queryKey, filterRecord, transform) {
        if (!filterRecord)
            return;
        const include = [];
        const exclude = [];
        Object.entries(filterRecord).forEach((params) => {
            const [_item, value] = transform ? transform(params[0], params[1]) : params;
            const item = `${_item || ''}`.toLowerCase().trim();
            if (!(item && typeof value === 'boolean'))
                return;
            if (value)
                include.push(item);
            else if (value === false)
                exclude.push(item);
        });
        if (groupByKey) {
            if (include.length)
                queries.push(`${queryKey}:${lodash_1.default.sortBy(include).join(',')}`);
            if (exclude.length)
                queries.push(`-${queryKey}:${lodash_1.default.sortBy(exclude).join(',')}`);
        }
        else {
            const all = lodash_1.default.sortBy(lodash_1.default.uniq([...include, ...exclude])).filter(Boolean);
            all.forEach((value) => queries.push(`${exclude.includes(value) ? '-' : ''}${queryKey}:${value}`));
        }
    }
    const inbox = getItemInbox(type, filters);
    if (inbox !== 'all' || type === 'notifications') {
        queries.push(`inbox:${inbox}`);
    }
    if (owners) {
        const { ownerFilters, repoFilters } = filters_1.getOwnerAndRepoFormattedFilter({
            owners,
        });
        handleRecordFilter('owner', ownerFilters);
        handleRecordFilter('repo', repoFilters);
    }
    if (involves) {
        handleRecordFilter('involves', involves);
    }
    if (typeof saved === 'boolean') {
        const n = getMaybeNegate(saved);
        queries.push(`${n}is:saved`);
    }
    if (unread === true)
        queries.push('is:unread');
    if (unread === false)
        queries.push('is:read');
    if (typeof _private === 'boolean')
        queries.push(_private ? 'is:private' : 'is:public');
    if (subjectTypes)
        handleRecordFilter('is', subjectTypes, (_key, value) => {
            const key = `${_key || ''}`.toLowerCase().trim();
            if (key === 'pullrequest')
                return ['pr', value];
            return [key, value];
        });
    if (states)
        handleRecordFilter('is', states);
    if (typeof bot === 'boolean') {
        const n = getMaybeNegate(bot);
        queries.push(`${n}is:bot`);
    }
    if (typeof draft === 'boolean') {
        const n = getMaybeNegate(draft);
        queries.push(`${n}is:draft`);
    }
    if (notifications && notifications.reasons)
        handleRecordFilter('reason', notifications.reasons, (k, v) => [k && k.toLowerCase() === 'subscribed' ? 'watching' : k, v]);
    if (activity && activity.actions)
        handleRecordFilter('action', activity.actions);
    if (watching)
        handleRecordFilter('watching', watching);
    // if (clearedAt) queries.push(`clear:${clearedAt}`)
    const queryTerms = getSearchQueryTerms(query);
    let remainingQuery = '';
    const queryObj = {};
    queryTerms.forEach((queryTerm) => {
        if (!queryTerm)
            return;
        if (queryTerm.length === 2) {
            const [q, isNegated] = queryTerm;
            remainingQuery = `${remainingQuery.trim()} ${isNegated ? '-' : ''}${q}`.trim();
        }
        else if (queryTerm.length === 3) {
            const [k, v, isNegated] = queryTerm;
            queryObj[k] = queryObj[k] || {};
            queryObj[k][v] = !isNegated;
        }
    });
    Object.entries(queryObj).forEach(([queryKey, filterRecord]) => {
        handleRecordFilter(queryKey, filterRecord);
    });
    if (remainingQuery)
        queries.push(remainingQuery.trim());
    return queries.join(' ');
}
exports.getSearchQueryFromFilter = getSearchQueryFromFilter;
function getQueryStringFromQueryTerms(queryTerms) {
    let query = '';
    queryTerms.forEach((queryTerm) => {
        if (!queryTerm)
            return;
        if (queryTerm.length === 2) {
            const [q, isNegated] = queryTerm;
            query = `${query.trim()} ${isNegated ? '-' : ''}${q}`.trim();
        }
        else if (queryTerm.length === 3) {
            const [k, v, isNegated] = queryTerm;
            query = `${query.trim()} ${isNegated ? '-' : ''}${k}:${v}`.trim();
        }
    });
    return query;
}
exports.getQueryStringFromQueryTerms = getQueryStringFromQueryTerms;
function getSearchQueryTerms(query) {
    if (!(query && typeof query === 'string'))
        return [];
    const result = [];
    const q = query.trim();
    (q.match(/((-|NOT )?[a-zA-Z]+:"[^"]+")|((-|NOT )?[a-zA-Z]+:[^ \n$]+)|((-|NOT )?"[^"]+")|(-|NOT )?([^ $]+)/gi) || []).forEach((_queryItem) => {
        if (!_queryItem)
            return;
        const queryItem = _queryItem.replace(/^(^|\s)NOT(\s)/gi, '$1-');
        const [_keyOrValue, ..._values] = queryItem[0] === '"' || (queryItem[0] === '-' && queryItem[1] === '"') ? [queryItem] : queryItem.split(':');
        const isNegated = !!(_keyOrValue && _keyOrValue[0] === '-');
        const keyOrValue = (_keyOrValue || '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLowerCase()
            .slice(isNegated ? 1 : 0);
        const value = _values.join(':').replace(/\s+/g, ' ').trim().toLowerCase();
        function handleValue(v) {
            if (keyOrValue && !v) {
                result.push([keyOrValue, isNegated]);
            }
            else if (keyOrValue && v) {
                result.push([keyOrValue, v, isNegated]);
            }
        }
        // handle queries with comma, like: owner:facebook,styled-components
        // by splitting them into: owner:facebook owner:styled-components
        if (keyOrValue && value && !value.startsWith('"') && value.split(',').length > 1) {
            value.split(',').map((subItem) => subItem && handleValue(subItem.trim()));
        }
        else {
            handleValue(value);
        }
    });
    return result;
}
exports.getSearchQueryTerms = getSearchQueryTerms;
function getFilterFromSearchQuery(type, query, otherFilters) {
    const filters = {
        ...otherFilters,
    };
    if (!type)
        return filters;
    const searchTerms = getSearchQueryTerms(query);
    let unknownKeyValueQueries = '';
    filters.query = '';
    searchTerms.forEach((searchTerm) => {
        if (Array.isArray(searchTerm) && searchTerm.length === 2) {
            const [_query, _isNegated] = searchTerm;
            if (!(_query && typeof _query === 'string' && typeof _isNegated === 'boolean'))
                return;
            const _str = `${_isNegated ? '-' : ''}${_query}`;
            filters.query = `${filters.query} ${_str}`.trim();
            return;
        }
        if (!(Array.isArray(searchTerm) && searchTerm.length === 3))
            return;
        const [key, value, isNegated] = searchTerm;
        if (!(key && value && typeof key === 'string' && typeof value === 'string' && typeof isNegated === 'boolean'))
            return;
        const activityFilters = filters;
        const issueOrPRFilters = filters;
        const notificationsFilters = filters;
        switch (key) {
            case 'inbox': {
                const inbox = `${value || ''}`.toLowerCase().trim();
                if (type === 'notifications') {
                    notificationsFilters.notifications = notificationsFilters.notifications || {};
                    notificationsFilters.notifications.participating = inbox === 'participating';
                }
                break;
            }
            case 'org':
            case 'owner':
            case 'user': {
                const owner = `${value || ''}`.toLowerCase().trim();
                filters.owners = filters.owners || {};
                filters.owners[owner] = filters.owners[owner] || {
                    repos: {},
                    value: undefined,
                };
                filters.owners[owner].value = !isNegated;
                break;
            }
            case 'repo': {
                const repoFullName = `${value || ''}`.toLowerCase().trim();
                const { owner, repo } = github_1.getOwnerAndRepo(repoFullName);
                if (!(owner && repo))
                    return;
                filters.owners = filters.owners || {};
                filters.owners[owner] = filters.owners[owner] || {
                    repos: {},
                    value: undefined,
                };
                filters.owners[owner].repos = filters.owners[owner].repos || {};
                filters.owners[owner].repos[repo] = !isNegated;
                break;
            }
            case 'involves': {
                const user = `${value || ''}`.toLowerCase().trim();
                issueOrPRFilters.involves = issueOrPRFilters.involves || {};
                issueOrPRFilters.involves[user] = !isNegated;
                break;
            }
            case 'is': {
                switch (value) {
                    case 'saved': {
                        filters.saved = !isNegated;
                        break;
                    }
                    case 'unread': {
                        filters.unread = !isNegated;
                        break;
                    }
                    case 'read': {
                        filters.unread = !!isNegated;
                        break;
                    }
                    case 'public': {
                        filters.private = !!isNegated;
                        break;
                    }
                    case 'private': {
                        filters.private = !isNegated;
                        break;
                    }
                    case 'bot': {
                        filters.bot = !isNegated;
                        break;
                    }
                    case 'draft': {
                        filters.draft = !isNegated;
                        break;
                    }
                    case 'open': {
                        filters.state = filters.state || {};
                        filters.state.open = !isNegated;
                        break;
                    }
                    case 'closed': {
                        filters.state = filters.state || {};
                        filters.state.closed = !isNegated;
                        break;
                    }
                    case 'merged': {
                        filters.state = filters.state || {};
                        filters.state.merged = !isNegated;
                        break;
                    }
                    case 'pr': {
                        filters.subjectTypes = filters.subjectTypes || {};
                        filters.subjectTypes.PullRequest = !isNegated;
                        break;
                    }
                    default: {
                        const validSubjectTypes = type === 'activity' ? github_1.eventSubjectTypes : type === 'issue_or_pr' ? github_1.issueOrPullRequestSubjectTypes : type === 'notifications' ? github_1.notificationSubjectTypes : github_1.allSubjectTypes;
                        if (validSubjectTypes.map((subjectType) => subjectType.toLowerCase()).includes(value)) {
                            filters.subjectTypes = filters.subjectTypes || {};
                            validSubjectTypes.forEach((subjectType) => {
                                if (subjectType.toLowerCase() === value) {
                                    ;
                                    filters.subjectTypes[subjectType] = !isNegated;
                                }
                            });
                            break;
                        }
                        // TODO: Investigate
                        // for some reason that I don't know,
                        // the code was not going to the next "default" here,
                        // so I had to copy-paste the code code below
                        if (key && value) {
                            const q = `${isNegated ? '-' : ''}${key}:${value}`;
                            unknownKeyValueQueries = `${unknownKeyValueQueries} ${q}`.trim();
                            break;
                        }
                    }
                }
            }
            case 'action': {
                if (type !== 'activity')
                    return;
                const action = `${value || ''}`.toLowerCase().trim();
                activityFilters.activity = activityFilters.activity || {};
                activityFilters.activity.actions = activityFilters.activity.actions || {};
                // invalid
                if (!github_1.eventActions.includes(action))
                    return;
                activityFilters.activity.actions[action] = !isNegated;
                break;
            }
            case 'state': {
                const state = `${value || ''}`.toLowerCase().trim();
                filters.state = filters.state || {};
                // invalid
                if (!github_1.issueOrPullRequestStateTypes.includes(state))
                    return;
                filters.state[state] = !isNegated;
                break;
            }
            case 'type': {
                const subjectType = `${value || ''}`.toLowerCase().trim();
                filters.subjectTypes = filters.subjectTypes || {};
                const subjectTypesFilter = filters.subjectTypes;
                // invalid
                if (!github_1.allSubjectTypes.includes(subjectType))
                    return;
                subjectTypesFilter[subjectType] = !isNegated;
                break;
            }
            case 'reason': {
                if (type !== 'notifications')
                    return;
                let reason = `${value || ''}`.toLowerCase().trim();
                if (reason === 'watching')
                    reason = 'subscribed';
                notificationsFilters.notifications = notificationsFilters.notifications || {};
                notificationsFilters.notifications.reasons = notificationsFilters.notifications.reasons || {};
                const reasonsFilter = notificationsFilters.notifications.reasons;
                // invalid
                if (!github_1.notificationReasons.includes(reason))
                    return;
                reasonsFilter[reason] = !isNegated;
                break;
            }
            case 'watching': {
                if (type !== 'activity')
                    return;
                const owner = `${value || ''}`.toLowerCase().trim();
                activityFilters.watching = activityFilters.watching || {};
                activityFilters.watching[owner] = !isNegated;
                break;
            }
            default: {
                if (key && value) {
                    const q = `${isNegated ? '-' : ''}${key}:${value}`;
                    unknownKeyValueQueries = `${unknownKeyValueQueries} ${q}`.trim();
                }
                return;
            }
        }
    });
    filters.query = filters.query || '';
    if (unknownKeyValueQueries)
        filters.query = `${unknownKeyValueQueries} ${filters.query}`.trim();
    return filters;
}
exports.getFilterFromSearchQuery = getFilterFromSearchQuery;
function getValuesFromQueryKeysFilter(type, queryKeys, filters) {
    const filtersQuery = getSearchQueryFromFilter(type, filters, {
        groupByKey: true,
    }) || undefined;
    const queryTerms = getSearchQueryTerms(filtersQuery);
    const filteredQueryTerms = lodash_1.default.sortBy(queryTerms.filter((queryTerm) => queryTerm && queryTerm.length === 3 && queryKeys.includes(queryTerm[0])), ['0', '2']);
    const usedQueryKeys = lodash_1.default.uniq(filteredQueryTerms.map((queryTerm) => queryTerm[0]));
    const filterObjs = {
        including: {},
        excluding: {},
    };
    filteredQueryTerms.forEach((queryTerm) => {
        const [key, value, isNegated] = queryTerm;
        if (isNegated) {
            filterObjs.excluding[key] = filterObjs.excluding[key] || [];
            filterObjs.excluding[key].push(value);
        }
        else {
            filterObjs.including[key] = filterObjs.including[key] || [];
            filterObjs.including[key].push(value);
        }
    });
    let included = [];
    Object.entries(filterObjs.including).forEach(([_queryKey, _usernames]) => {
        included = lodash_1.default.uniq(included.concat(_usernames));
    });
    let excluded = [];
    Object.entries(filterObjs.excluding).forEach(([_queryKey, _usernames]) => {
        excluded = lodash_1.default.uniq(excluded.concat(_usernames));
    });
    return {
        all: lodash_1.default.uniq(included.concat(excluded)),
        included,
        excluded,
        usedQueryKeys,
    };
}
exports.getValuesFromQueryKeysFilter = getValuesFromQueryKeysFilter;
function getUsernamesFromFilter(type, filters, { blacklist = [], whitelist = ['assignee', 'author', 'commenter', 'involves', 'mentions', 'org', 'owner', 'review-requested', 'reviewed-by', 'team', 'team-review-requested', 'user', 'watching'], } = {}) {
    const usernameFilterKeys = whitelist.filter((key) => !blacklist.includes(key));
    const { all, excluded, included, usedQueryKeys } = getValuesFromQueryKeysFilter(type, usernameFilterKeys, filters);
    return {
        allUsernames: all,
        excludedUsernames: excluded,
        includedUsernames: included,
        usernameFilterKeys,
        usedUsernameFilterKeys: usedQueryKeys,
    };
}
exports.getUsernamesFromFilter = getUsernamesFromFilter;
function getItemsFromSubscriptions(subscriptions, getItemByNodeIdOrId) {
    const itemNodeIdOrIds = [];
    const result = [];
    if (!(subscriptions && subscriptions.length))
        return result;
    subscriptions.forEach((subscription) => {
        if (!(subscription && subscription.data && subscription.data.itemNodeIdOrIds && subscription.data.itemNodeIdOrIds.length))
            return;
        subscription.data.itemNodeIdOrIds.forEach((_id) => {
            const id = `${_id || ''}`;
            if (!id)
                return;
            if (itemNodeIdOrIds.includes(id))
                return;
            const item = getItemByNodeIdOrId(id);
            if (!item)
                return;
            itemNodeIdOrIds.push(id);
            result.push(item);
        });
    });
    if (!result.length)
        return result;
    if (subscriptions[0] && subscriptions[0].type === 'activity') {
        return github_1.sortEvents(result);
    }
    if (subscriptions[0] && subscriptions[0].type === 'issue_or_pr') {
        return github_1.sortIssuesOrPullRequests(result);
    }
    if (subscriptions[0] && subscriptions[0].type === 'notifications') {
        return github_1.sortNotifications(result);
    }
    console.error(`Unhandled subscription type`, subscriptions);
    return result;
}
exports.getItemsFromSubscriptions = getItemsFromSubscriptions;
function getItemInbox(type, filters) {
    if (type === 'notifications') {
        const f = filters;
        return f && f.notifications && f.notifications.participating ? 'participating' : 'all';
    }
    return 'all';
}
exports.getItemInbox = getItemInbox;
function getColumnOptionMetadata({ Platform }) {
    return {
        enableAppIconUnreadIndicator: {
            hasAccess: true,
            platformSupports: Platform.OS === 'web',
        },
        enableInAppUnreadIndicator: {
            hasAccess: true,
            platformSupports: true,
        },
        enableDesktopPushNotifications: {
            hasAccess: true,
            platformSupports: Platform.isElectron,
        },
    };
}
exports.getColumnOptionMetadata = getColumnOptionMetadata;
function getColumnOption(column, option, { Platform, }) {
    if (!(column && column.type))
        return { hasAccess: false, platformSupports: false, value: undefined };
    const details = getColumnOptionMetadata({ Platform });
    if (option === 'enableAppIconUnreadIndicator') {
        return {
            ...details.enableAppIconUnreadIndicator,
            value: column.options && typeof column.options.enableAppIconUnreadIndicator === 'boolean' ? column.options.enableAppIconUnreadIndicator : Platform.OS === 'web' ? column.type === 'notifications' : false,
        };
    }
    if (option === 'enableInAppUnreadIndicator') {
        return {
            ...details.enableInAppUnreadIndicator,
            value: column.options && typeof column.options.enableInAppUnreadIndicator === 'boolean' ? column.options.enableInAppUnreadIndicator : true,
        };
    }
    if (option === 'enableDesktopPushNotifications') {
        return {
            ...details.enableDesktopPushNotifications,
            value: column.options && typeof column.options.enableDesktopPushNotifications === 'boolean' ? column.options.enableDesktopPushNotifications : Platform.isElectron ? column.type === 'notifications' : false,
        };
    }
    return {
        hasAccess: false,
        platformSupports: false,
        value: column.options && column.options[option],
    };
}
exports.getColumnOption = getColumnOption;
function fixDateToISO(date) {
    if (!date)
        return undefined;
    let _date = date;
    if (typeof _date === 'string')
        _date = new Date(_date);
    let timestamp = null;
    if (_date instanceof Date)
        timestamp = _date.getTime();
    if (typeof _date === 'number')
        timestamp = _date;
    if (timestamp && timestamp.toString().length <= 10)
        timestamp = timestamp * 1000 + new Date().getTimezoneOffset() * 60 * 1000;
    if (date && typeof date === 'string' && !date.includes('Z') && timestamp)
        timestamp = timestamp + new Date().getTimezoneOffset() * 60 * 1000;
    if (!(timestamp && timestamp.toString().length >= 13))
        return undefined;
    return new Date(timestamp).toISOString();
}
exports.fixDateToISO = fixDateToISO;
// new Date(new Date('2019-11-24 22:48:21').getTime() + (new Date().getTimezoneOffset() * 60 * 1000))
function addDashesToString(str, addDashEvery = 0) {
    if (!(str && typeof str === 'string'))
        return undefined;
    if (!(addDashEvery && addDashEvery >= 1))
        return str;
    return str
        .split('')
        .reduce((arr, char) => {
        if (arr.length && arr[arr.length - 1].length < addDashEvery) {
            arr[arr.length - 1] += `${char}`;
            return arr;
        }
        return [...arr, char];
    }, [])
        .join('-');
}
exports.addDashesToString = addDashesToString;
//# sourceMappingURL=shared.js.map